export enum GtfsImportWarningType {
  REPEATED_STOPS = 'REPEATED_STOPS',
  NO_STOP_TIMES = 'NO_STOP_TIMES',
  MISSING_CALENDAR = 'MISSING_CALENDAR',
  ROUTE_WITHOUT_TRIPS = 'ROUTE_WITHOUT_TRIPS'
}
